import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import "./Congratulation.css";
import { useAuthStudent } from "../../../context/StudentLoginContext/StudentAuthContext";
import { StudentMapMenuLight } from "../Map/MapMenu/MapMenuLight";
import { useAuth } from "../../../context/LoginContext/AuthContext";
import UnlockCertificatePopup from "../../../common/AuthV2/UnlockCertificatePopup";

export const StudentAdminCongo = () => {
  const { student, fetchWithAuthStudent } = useAuthStudent();
  const apiUrl = process.env.REACT_APP_API_URL;
  const [questChapterData, setQuestChapterData] = useState(null);
  const { questId, chapterId } = useParams();
  const { user } = useAuth();
  const currentUser = user?.user || student?.student;
  const isSubscribed =
    currentUser?.subscription_data?.is_subscribed || currentUser?.is_subscribed;
  const [showUnlockPopup, setShowUnlockPopup] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);

  useEffect(() => {
    const fetchChapterData = async () => {
      if (!student || !student.token) {
        return;
      }

      try {
        const response = await fetchWithAuthStudent(
          `${apiUrl}/student/quest-chapter/${chapterId}`,
          {
            method: "GET",
          },
        );

        if (!response.ok) {
          throw new Error("Failed to fetch chapters");
        }

        const data = await response.json();
        setQuestChapterData(data);
      } catch (error) {}
    };
    fetchChapterData();
  }, []);

  useEffect(() => {
    const awardCertificate = async (studentId, questId, chapterId) => {
      if (!student || !student.token) {
        return;
      }

      const formData = new FormData();
      formData.append("studentId", studentId);
      formData.append("questId", questId);
      formData.append("chapterId", chapterId);

      try {
        const response = await fetchWithAuthStudent(
          `${apiUrl}/student/award-certificate`,
          {
            method: "POST",
            body: formData, // Sending as form-data
          },
        );

        if (!response.ok) {
          // toast.error(result?.message );
        }
      } catch (error) {
        // toast.error("Network Error")
      }
    };
    awardCertificate(student?.student?.id, questId, chapterId);
  }, []);

  const handleProtectedClick = (e) => {
    // ❌ Not logged in → Login modal
    if (!currentUser) {
      e.preventDefault();
      setShowAuthModal(true);
      return;
    }

    const isSubscribed =
      currentUser?.subscription_data?.is_subscribed ||
      currentUser?.is_subscribed;

    // 🔒 Not subscribed → show THIS popup
    if (!isSubscribed) {
      e.preventDefault();
      setShowUnlockPopup(true);
      return;
    }

    // ✅ Subscribed → allow navigation
  };

  return (
    <>
      <div className="SchlStdntCongoBg">
        <div className="container-fluid">
          <img
            src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/congratulations/certificate/CongratulationsBackground.png"
            alt="background"
            className="fullscreen-image"
          />
        </div>

        <div
          className="teacher-bodycontent d-flex justify-content-center align-items-center"
          style={{ minHeight: "100vh", position: "relative" }}
        >
          <div style={{ position: "relative" }}>
            {/* Background Image */}
            <img
              alt="greatJob"
              src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/congratulations/certificate/GreatJobBackground.png"
              className="img-fluid  jobBackground-img"
              style={{ maxWidth: "100%", height: "auto" }}
            />
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                textAlign: "center",
                color: "white",
                width: "100%",
                padding: "0 30px", // optional: padding for small screens
              }}
            >
              <img
                src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/congratulations/certificate/GreatJob.png"
                alt="Great Job"
                className="img-fluid mb-1 responsive-img"
                style={{
                  maxWidth: "80%", // or 100%, depending on the layout
                  height: "auto", // maintains aspect ratio
                }}
              />

              <img
                src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/congratulations/certificate/BlueLogo.png"
                alt=""
                className="position-absolute logo blue-logo"
              />
              <img
                src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/congratulations/certificate/PurpleLogo.png"
                alt=""
                className="position-absolute logo purple-logo"
              />

              <p className="custom-text">
                {/* you have unloacked a new quest certificate */}
                You’ve unlocked a new{" "}
                <Link
                  to={isSubscribed ? `/student/admin/certificates/${questId}` : "#"}
                  onClick={handleProtectedClick}
                >
                  certificate
                </Link>{" "}
                in your journey
              </p>
              {isSubscribed ? (
                <div
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    gap: "15px",
                    justifyContent: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <Link
                    style={{
                      background:
                        "linear-gradient(172.64deg, #FDC526 4.73%, #FF9203 93.58%)",
                      color: "#333333",
                      borderRadius: "40px",
                      padding: "10px 30px",
                      fontSize: "14px",
                      fontWeight: "600",
                      display: "inline-block",
                      textDecoration: "none",
                    }}
                    to={`/student/admin/certificates/${questId || questChapterData?.chapter?.questID}`}
                  >
                    View Certificate
                  </Link>
                  {questChapterData?.next_chapter && (
                    <Link
                      style={{
                        background: "#0037AC",
                        color: "#ffffff",
                        borderRadius: "40px",
                        padding: "10px 30px",
                        fontSize: "14px",
                        fontWeight: "600",
                        display: "inline-block",
                        textDecoration: "none",
                      }}
                      to={`/student/admin/episodes/detail/${questId}/${questChapterData.next_chapter.id}`}
                    >
                      Next Episode
                    </Link>
                  )}
                </div>
              ) : (
                <Link
                  style={{
                    background:
                      "linear-gradient(172.64deg, #FDC526 4.73%, #FF9203 93.58%)",
                    color: "#333333",
                    borderRadius: "40px",
                    padding: "10px 30px",
                    fontSize: "14px",
                    fontWeight: "600",
                    display: "inline-block",
                    textDecoration: "none",
                  }}
                  to="#"
                  onClick={handleProtectedClick}
                >
                  Unlock Certificate
                </Link>
              )}
            </div>
          </div>
        </div>

        {/* Footer with highest z-index */}
        <div style={{ position: "relative", zIndex: 4 }}>
          <StudentMapMenuLight />
        </div>
      </div>

      <UnlockCertificatePopup
        modalTitle="HURRAY! QUEST COMPLETED"
        modalDesc="Your Certificate is Ready."
        showModal={showUnlockPopup}
        handleClose={() => setShowUnlockPopup(false)}
      />
      {/* </div> */}
    </>
  );
};
